document.addEventListener('DOMContentLoaded', function() {
  const parallaxImages = document.querySelectorAll('[data-parallax-image]');
  
  if (parallaxImages.length === 0) return;
  
  // Low speed for subtle movement
  const speed = 0.15;
  
  function updateParallax() {
    const scrolled = window.pageYOffset;
    const windowHeight = window.innerHeight;
    
    parallaxImages.forEach(image => {
      const container = image.closest('.image-effect-container');
      if (!container) return;
      
      const rect = container.getBoundingClientRect();
      const containerTop = rect.top + scrolled;
      
      // Only animate when element is in viewport
      if (rect.top < windowHeight && rect.bottom > 0) {
        // Calculate movement relative to when it enters viewport
        const startPoint = containerTop - windowHeight;
        const relativeScroll = scrolled - startPoint;
        
        // Scroll down = move up (negative translateY)
        const translateY = -relativeScroll * speed;
        image.style.transform = `translateY(${translateY}px)`;
      }
    });
  }
  
  // Update on scroll
  let ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        updateParallax();
        ticking = false;
      });
      ticking = true;
    }
  });
  
  // Initial update
  updateParallax();
});